import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/user';
import { map } from 'rxjs/operators';


const headers = new HttpHeaders({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'POST, PUT, DELETE '
});

@Injectable()
export class AuthenticationService {

  changePasswordUrl = '/superadmin/rest/mgmt/login/chpwd';
  superadmin_loginUrl = '/superadmin/rest/mgmt/login';
  verifySecondPassUrl = '/superadmin/rest/mgmt/login/checkpwd';
  support_loginUrl = '/superadmin/rest/support/login';
  marketing_loginUrl = '/superadmin/rest/marketing/login';
  loginToProviderUrl = '/v1/rest/superadmin/login';



  constructor(private http: HttpClient) { }

  login(usr: User) {
    return this.http.post(this.superadmin_loginUrl, usr, { headers: headers }).pipe(map(userObj => {
        if (userObj) {
          localStorage.setItem('supportName', usr.loginId);
          localStorage.setItem('supportPass', usr.password);
          localStorage.setItem('userType', 'superadmin');
        }
        return userObj;
      }));
  }
  support_login(usr: User) {
    return this.http.post(this.support_loginUrl, usr, { headers: headers }).pipe(map(userObj => {
        if (userObj) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('supportName', usr.loginId);
          localStorage.setItem('supportPass', usr.password);
          localStorage.setItem('userType', 'support');
        }

        return userObj;
      }));
  }
  marketing_login(usr: User) {
    return this.http.post(this.marketing_loginUrl, usr, { headers: headers }).pipe(map(userObj => {
      if (userObj) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('supportName', usr.loginId);
        localStorage.setItem('supportPass', usr.password);
        localStorage.setItem('userType', 'marketing');
      }
      return userObj;
    }));
  }
  logout() {
    let logoutUrl;
    const userType = localStorage.getItem('userType');
    console.log(userType);
    if (userType === 'superadmin') {
      logoutUrl = this.superadmin_loginUrl;
    } else if (userType === 'marketing') {
      logoutUrl = this.marketing_loginUrl;
    } else {
      logoutUrl = this.support_loginUrl;
    }
    // remove user from local storage to log user out
    localStorage.removeItem('supportName');
    localStorage.removeItem('supportPass');
    localStorage.removeItem('userType');
    return this.http.delete(logoutUrl, { headers: headers });
  }

  changePassword(dataObj) {
    return this.http.put(this.changePasswordUrl, dataObj, { headers: headers });
  }
  verifySecondPassword(data) {
    return this.http.post(this.verifySecondPassUrl, data, { headers: headers });
  }


  clearStorage(_user, domain) {
    return this.http.delete(domain + this.loginToProviderUrl, { headers: headers });
  }
  logintoProviderAccount(_user, domain) {

    return this.http.post(domain + this.loginToProviderUrl, _user, { headers: headers });
  }



}


